import React from 'react';
import { Button } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { lightBackgroundButtonStyles } from '../styles/button';
import { buttonIconStyles } from '../styles/icon';

interface CancelProps {
  buttonText?: string;
  iconType?: 'ArrowBackIcon' | 'DeleteOutlineOutlinedIcon';
}

function Cancel({
  buttonText = 'Cancel',
  iconType = 'DeleteOutlineOutlinedIcon',
}: CancelProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard', { replace: true });
  };

  const IconComponent = iconType === 'ArrowBackIcon' ? ArrowBackIcon : DeleteOutlineOutlinedIcon;

  return (
    <Button
      variant="text"
      sx={{ ...lightBackgroundButtonStyles, width: '6rem' }}
      startIcon={
        <IconComponent sx={{ ...buttonIconStyles, color: '#373737' }} />
      }
      onClick={handleClick}
    >
      {buttonText}
    </Button>
  );
}

export default Cancel;
